"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const react_1 = __importStar(require("react"));
const constants_1 = require("../../BuyModal/constants");
const Loader_1 = __importDefault(require("../../Loader"));
const styled_1 = require("./styled");
const CEX_URL = "https://api.cexdirect.com/";
const CEXWidget = (_a) => {
    var { crypto, fiat, fiatValue, cryptoAmount, placementId, walletAddr } = _a, rest = __rest(_a, ["crypto", "fiat", "fiatValue", "cryptoAmount", "placementId", "walletAddr"]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [frameSrc, setFrameSrc] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        const getFrameUrl = () => __awaiter(void 0, void 0, void 0, function* () {
            const placement = `placementId=${placementId || constants_1.CEX_PLACEMENT_ID}`;
            const wallet = walletAddr ? `wallet=${walletAddr}` : null;
            try {
                const { data } = yield axios_1.default.get(`https://api.cexdirect.com/api/v1/payments/currencies/${placementId || constants_1.CEX_PLACEMENT_ID}`);
                const { data: { data: { precisions }, }, } = yield axios_1.default.get(`https://api.cexdirect.com/api/v1/merchant/precisions/${placementId || constants_1.CEX_PLACEMENT_ID}`);
                const cryptoPrecision = precisions.find((i) => i.currency === crypto);
                const curr = data.data.currencies.find((i) => i.crypto === (crypto === null || crypto === void 0 ? void 0 : crypto.toUpperCase()) && i.fiat === (fiat === null || fiat === void 0 ? void 0 : fiat.toUpperCase()));
                const calculatorValues = `calculatorValues=${JSON.stringify({
                    fiatCurrency: fiat === null || fiat === void 0 ? void 0 : fiat.toUpperCase(),
                    fiatValue,
                    cryptoCurrency: crypto === null || crypto === void 0 ? void 0 : crypto.toUpperCase(),
                    cryptoValue: curr
                        ? ((curr.a * Number(fiatValue) - curr.b) / curr.c).toFixed(cryptoPrecision.visiblePrecision)
                        : null,
                })}`;
                const queries = [placement, wallet, calculatorValues];
                const url = `${CEX_URL}?${queries.filter(x => x).join("&")}`;
                setFrameSrc(url);
            }
            catch (error) {
                // eslint-disable-next-line no-console
                console.log(error);
                const calculatorValues = `calculatorValues=${JSON.stringify({
                    fiatCurrency: fiat === null || fiat === void 0 ? void 0 : fiat.toUpperCase(),
                    fiatValue,
                    cryptoCurrency: crypto === null || crypto === void 0 ? void 0 : crypto.toUpperCase(),
                    cryptoValue: cryptoAmount,
                })}`;
                const queries = [placement, wallet, calculatorValues];
                const url = `${CEX_URL}?${queries.filter(x => x).join("&")}`;
                setFrameSrc(url);
            }
        });
        getFrameUrl();
    }, [crypto, cryptoAmount, fiat, fiatValue, placementId, walletAddr]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        loading && (react_1.default.createElement(styled_1.LoaderContainer, null,
            react_1.default.createElement(Loader_1.default, null))),
        frameSrc && (react_1.default.createElement("iframe", Object.assign({ title: "CEX Widget", allow: "geolocation", height: "500px", width: "100%", style: { border: 0 }, src: frameSrc, onLoad: () => {
                setLoading(false);
            } }, rest)))));
};
exports.default = CEXWidget;
//# sourceMappingURL=CEXWidget.js.map